import searchBus, { type BusSearchResult } from '@/api/searchBus';
import { useState } from 'react';
import { Link } from 'react-router';

export default function SearchPage() {
	const [searchTerm, setSearchTerm] = useState('');
	const [searchResults, setSearchResults] = useState([] as BusSearchResult[]);

	const handleSearch = async () => {
		const response = await searchBus(searchTerm);
		setSearchResults(response);
	};

	const renderSearchResult = (result: BusSearchResult) => {
		const terminal1 = result.sl === 1 ? result.ts : result.tp;
		const terminal2 = result.sl === 1 ? result.tp : result.ts;

		const name = `${result.lt}-${result.tl}`;
		const lineInfo = `${terminal1} ➡️ ${terminal2}`;

		return (
			<Link to={`/linha?linha=${name}&sentido=${result.sl}`} className='search-result-container'>
				<div key={result.cl}>
					<h3>{name}</h3>
					<p>{lineInfo}</p>
				</div>
			</Link>
		);
	};

	return (
		<div className="page-container">
			<h1>Pesquisa de Linhas</h1>

			<div className="center-container">
				<span>Pesquise por número ou nome da linha:</span>
				<input
					type="text"
					placeholder="Ex: 5010-10 ou Jabaquara"
					value={searchTerm}
					onChange={(e) => setSearchTerm(e.target.value)}
					onKeyDown={(e) => {
						if (e.key === 'Enter') handleSearch();
					}}
				/>
				<button onClick={handleSearch}>Pesquisar</button>
			</div>

			{searchResults.length > 0 && (
				<div>
					<h3>{searchResults.length} resultados encontrados</h3>
					{searchResults.map((result) => renderSearchResult(result))}
				</div>
			)}
		</div>
	);
}
